import { render } from "./Commerce.vue?vue&type=template&id=e3ec5952&scoped=true"
import script from "./Commerce.vue?vue&type=script&lang=js"
export * from "./Commerce.vue?vue&type=script&lang=js"

import "./Commerce.vue?vue&type=style&index=0&id=e3ec5952&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3ec5952"]])

export default __exports__